import React, { useMemo } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { StyleProp, TextStyle } from 'react-native';
import { VacancyAbsence } from '../../services/central-api/deac';


interface Props {
    value: VacancyAbsence | null;
    setValue: React.Dispatch<React.SetStateAction<VacancyAbsence | null>>;
    zIndex: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    disabled?: boolean;
}

export default function AbsenceTypeDropdown({ value, setValue, zIndex, labelStyle, viewStyle, disabled }: Props) {
    const items = useMemo(() => [
        { label: 'justifiedAbsence', value: 'justified' },
        { label: 'unjustifiedAbsence', value: 'unjustified' },
    ].map(item => {
        return { label: translate(item.label), value: item.value };
    }), []);

    return (
        <FilterDropdown
            label={translate('absenceType')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
            disabled={disabled}
        />
    );
}
